import { motion } from "framer-motion";

interface FadeTransitionProps {
    children: React.ReactNode;
  }

export default function FadeTransition ({ children }: FadeTransitionProps) {
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
        >
            {children}
        </motion.div>
    );
};